import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import FaqPage from './Components/FaqPage';
import ContactPage from './Components/ContatPage';
import Footer from './Components/Footer';
import NotFound from './NotFound';
import TutorialPage from './Components/TutorialsPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contacts" element={<ContactPage />} />
          <Route path="/tutorial" element={<TutorialPage />} />
          {/* Catch-all route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Navbar />
        <Footer />
      </div>
    </Router>
  );
}

export default App;